// C.1 — общий хелпер призыва юнита по cardId. Используется и Глобалом
// (бывший общий API), и Лив Лайфом (через livlife/summon.js).
//
// Сигнатура: summonUnit(state, ownerIdx, cardId, line, idx, parentCard?)
// Возвращает: новый экземпляр Card на поле, либо null если не удалось.

import { Card } from '../../card.js';
import { cards as cardsDeus } from '../../../data/cards-deus.js';
import { cards as cardsSyn } from '../../../data/cards-syntetics.js';
import { cards as cardsGlobal } from '../../../data/cards-global.js';
import { cards as cardsLivlife } from '../../../data/cards-livlife.js';
import { cards as cardsNeutral } from '../../../data/cards-neutral.js';

// Кэш шаблонов по id для всех фракций.
const TEMPLATE_BY_ID = (() => {
  const map = new Map();
  for (const list of [cardsDeus, cardsSyn, cardsGlobal, cardsLivlife, cardsNeutral]) {
    if (!Array.isArray(list)) continue;
    for (const t of list) if (t?.id) map.set(t.id, t);
  }
  return map;
})();

export function summonUnit(state, ownerIdx, cardId, line, idx, _parentCard = null) {
  if (!state || ownerIdx == null || !cardId) return null;
  const owner = state.players?.[ownerIdx];
  if (!owner) return null;
  if (line < 0 || line > 1 || idx < 0 || idx > 3) return null;
  if (owner.field?.[line]?.[idx] !== null) return null;

  const tpl = TEMPLATE_BY_ID.get(cardId);
  if (!tpl) {
    console.warn(`[Корпы] summonUnit: шаблон ${cardId} не найден`);
    return null;
  }

  const unit = new Card(tpl);
  unit.ownerId = ownerIdx;
  unit.line = line;
  unit.slot = idx;
  // Призывной юнит не подвержен Initiation Cooldown.
  unit.initiation = 0;
  if (typeof unit.markFreshlySummoned === 'function') {
    unit.markFreshlySummoned(state.currentTurn);
  } else if (typeof unit.justSummonedTurn !== 'undefined') {
    unit.justSummonedTurn = state.currentTurn;
  }

  owner.field[line][idx] = unit;
  return unit;
}
